import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

import { getOddsFromSelection } from './../../../sport-event/utils';
import MultiBetButton from './MultiBetButton';
import ContentSection from '../../ContentSection';

import i18n from './../../../../utils/i18n';
import { nextRepaint } from './../../../../utils/dom';
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';

import {
    ICON_ORANGE_DROPDOWN,
} from '../../../icon/constants';

import {
    BB_BETCARD_MULTI_CSS_CLASS_BLOCK_NAME,
    BB_BETCARD_MUTLI_HEADER_DETAILS_CSS_CLASS_NAME,
    BB_BETCARD_MUTLI_HEADER_DETAILS_LISTS_CSS_CLASS_NAME,
    BB_BETCARD_MUTLI_HEADER_STATUS_CSS_CLASS_NAME,
    BB_BETCARD_MUTLI_HEADER_CSS_CLASS_BLOCK_NAME,
    BB_BETCARD_MUTLI_HEADER_NUMBER_OF_ACCUMULATORS_CSS_CLASS_NAME,
    BB_ICON_SPORT_SIZE_24,
    BB_BETCARD_GRADIENT_CSS_CLASS_NAME,
    BB_BETCARD_GRADIENT_CSS_CLASS_NAME_HIDDEN_MODIFIER,
    BB_BETCARD_DROPDOWN_ICON_SIZE,
    BB_BETCARD_COLOR_TEXT_BLUE_CSS_CLASS_NAME_MODIFIER,
    I18N_BETCARD_SELECTIONS,
} from '../constants';

import { SP_ONLY_CODE } from './../../../sport-event/constants';

import {
    CSS_CLASS_BLOCK_NAME as BB_SPORT_SELECTION_CSS_CLASS_BLOCK_NAME,
} from '../../../sport-selection-view/constants';

import SportsSelectionViewContainer from './../../../../../shared/components/react/SportsSelectionView/SportsSelectionViewContainer';

class MultiBetCard extends React.Component {

    constructor(props) {
        super(props);
        /**
         * Event and selection might be removed by a websocket event. Shallow copy here
         * and if an update removes them, we deep copy them in componentWillUpdate()
         */
        this.backedSelections = [ ...this.props.selections ];
        this.backedEvents = { ...this.props.commonDataEvents };
        /**
         * Betcard is expired if a selection is 'off', 'resulted', etc. In these cases
         * events has been removed from the common store and we must refer to backed
         * selection data.
         */
        this.betcardExpired = false;

        this.state = {
            /**
             * Force bet button to suspend, e.g. in the event that the betcard is no longer
             * valid but still on the page.
             */
            forceSuspended: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.betcardExpired) {
            return;
        }

        let forceSuspended = this.state.forceSuspended;
        /**
         * Updates are likely from websocket events
         * @todo (JSON.stringify(prevProps) !== JSON.stringify(this.props)) is returning false
         * for event level updates on the commonDataStore, hence the logic check here. This should
         * be fixed to use best practice.
         */
        if (this.props.selections.length !== prevProps.selections.length) {
            /**
             * Special case when an event has been removed from the common data store, e.g.
             * due to a websocket event. In this case the card becomes "expired" and static,
             * and we must use backed events/selections.
             */
            forceSuspended = true;
            this.betcardExpired = true;
            // make sure a selection is suspended - doesn't matter which, this
            // card is now expired and will no longer receive updates
            Object.keys(this.backedSelections).some(selectionId => {

                this.backedSelections[selectionId].betable = false;
                const eventId = this.backedSelections[selectionId].event_id;
                this.backedEvents[eventId].betable = false;

                return true;
            });
        } else if (JSON.stringify(this.backedEvents.commonDataEvents) !== JSON.stringify(prevProps.commonDataEvents)) {
            /**
             * We have an update that does not cause the betcard to be expired. We just need to check for
             * a suspended event/market/selection.
             */
            this.props.betcard.selection_pointers.some(selP => {
                if (!isUndefined(this.props.commonDataEvents[selP.event_id])) {
                    const event = this.props.commonDataEvents[selP.event_id];
                    const market = event.markets[selP.market_id];
                    const selection = market.selections[selP.selection_id];
                    forceSuspended = (
                        (!isUndefined(event.betable) && !event.betable)
                        || (!isUndefined(market.betable) && !market.betable)
                        || (!isUndefined(selection.betable) && !selection.betable)
                    );
                }

                return forceSuspended;
            });
        }
        if (forceSuspended !== this.state.forceSuspended) {
            this.setState({ forceSuspended });
        }
    }

    static propTypes = {
        selections: PropTypes.array.isRequired,
        betcard: PropTypes.object.isRequired,
        commonDataEvents: PropTypes.object.isRequired,
        gtmAttribute: PropTypes.string,
    }

    static defaultProps = {
        gtmAttribute: '',
    }

    componentDidMount() {
        this.displayEllipsis();
    }

    displayEllipsis() {
        this.ulElMaxHeight = parseInt(window.getComputedStyle(this.ulElRef).maxHeight);
        this.ulElClientHeight = this.ulElRef.clientHeight;

        nextRepaint(() => {
            if (this.ulElClientHeight < this.ulElMaxHeight) {
                this.gradientElRef.classList.add(BB_BETCARD_GRADIENT_CSS_CLASS_NAME_HIDDEN_MODIFIER);
            } else {
                this.gradientElRef.classList.remove(BB_BETCARD_GRADIENT_CSS_CLASS_NAME_HIDDEN_MODIFIER);
            }
        });
    }

    renderHeaderDetailsSection () {
        const one = 1;
        let selectionsToUse = this.props.selections; // default
        if (this.betcardExpired) {
            selectionsToUse = this.backedSelections;
        }
        const selectionLength = Object.keys(selectionsToUse).length;
        const selectionsNames = Object.values(selectionsToUse).map(function (selection, index) {
            const hasNext = (index + one) && (selectionLength - one) > index;
            let selection_display_odds;
            if (isNull(selection.decimal_price)) {
                selection_display_odds = SP_ONLY_CODE;
            } else {
                selection_display_odds = getOddsFromSelection(selection);
            }

            return (
                <li key={selection.id}>
                    {selection.name}
                    <span className={BB_BETCARD_COLOR_TEXT_BLUE_CSS_CLASS_NAME_MODIFIER}> {selection_display_odds}</span>
                    {hasNext ? ',' : ''}
                </li>
            );
        });

        return (
            <div className={BB_BETCARD_MUTLI_HEADER_DETAILS_CSS_CLASS_NAME}>
                <ul className={BB_BETCARD_MUTLI_HEADER_DETAILS_LISTS_CSS_CLASS_NAME} ref={ref => { this.ulElRef = ref; }}>
                    {selectionsNames}
                    <span className={BB_BETCARD_GRADIENT_CSS_CLASS_NAME} ref={ref => { this.gradientElRef = ref; }}></span>
                </ul>
                <div className={BB_BETCARD_MUTLI_HEADER_NUMBER_OF_ACCUMULATORS_CSS_CLASS_NAME}>
                    <Trans
                        i18nKey={I18N_BETCARD_SELECTIONS}
                        count={selectionsToUse.length}
                        values={{bet_type: i18n.t(`bet_types.name.${this.props.betcard.bet_type}`)}}/>
                </div>
            </div>
        );
    }

    render() {
        const { gtmAttribute } = this.props;

        const contentSectionParams = {
            icon_type: ICON_ORANGE_DROPDOWN,
            icon_width: BB_BETCARD_DROPDOWN_ICON_SIZE,
            headerText: ' ',
            gtmAttribute: `${gtmAttribute};bet-card`,
        };

        return (
            <div className={BB_BETCARD_MULTI_CSS_CLASS_BLOCK_NAME}>
                <div className={BB_BETCARD_MUTLI_HEADER_CSS_CLASS_BLOCK_NAME}>
                    <div className={BB_SPORT_SELECTION_CSS_CLASS_BLOCK_NAME} >
                        <div className={BB_BETCARD_MUTLI_HEADER_STATUS_CSS_CLASS_NAME}>
                            <div className={BB_ICON_SPORT_SIZE_24}></div>
                        </div>
                        {this.renderHeaderDetailsSection()}
                        {this.betcardExpired ?
                            <MultiBetButton
                                betcard={this.props.betcard}
                                selections={this.backedSelections}
                                forceSuspended={this.state.forceSuspended}
                                gtmAttribute={gtmAttribute}
                            />
                        :
                            <MultiBetButton
                                betcard={this.props.betcard}
                                selections={this.props.selections}
                                forceSuspended={this.state.forceSuspended}
                                gtmAttribute={gtmAttribute}
                            />
                        }
                    </div>
                </div>

                <ContentSection params={contentSectionParams} showAsCollapsed>
                    {this.betcardExpired ?
                        Object.keys(this.backedSelections).map(idx => {
                        return <SportsSelectionViewContainer
                                    key={this.backedSelections[idx].id}
                                    selection={this.backedSelections[idx]}
                                    commonDataEvents={this.backedEvents}
                                    displaySelectionNameOdds
                               />;
                        })
                    :
                        Object.keys(this.props.selections).map(idx => {
                            return <SportsSelectionViewContainer
                                        key={this.props.selections[idx].id}
                                        selection={this.props.selections[idx]}
                                        commonDataEvents={this.props.commonDataEvents}
                                        displaySelectionNameOdds
                                   />;
                        })
                    }
                </ContentSection>
            </div>
        );
    }
}

export default MultiBetCard;
